<template>
  <div class="topnav">
    <div class="topnav-page">
      <div class="topnav-page_item"
           v-for="item in pageList"
           :key="item.id"
           :class="{'active':$route.path===item.path}" @click="gotoPage(item.path)">
        {{item.name}}
      </div>
    </div>
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    pageList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  methods:{
    gotoPage(url){
      this.$router.push({path:url})
    }
  }
}
</script>

<style lang="scss" scoped>
.topnav {
  height: 77px;
  padding: 0 30px 0 7px;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  align-items: center;
  color: #9b9b9b;
  border-bottom: 1px #e6e3e3 solid;
  .topnav-page {
    display: flex;
    .topnav-page_item {
      height: 20px;
      padding: 0px 23px;
      cursor: pointer;
      position: relative;
      border-right: 1px #dadada solid;
      &:last-child {
        border-right: none;
      }
      &.active {
        color: #f0722b;
        &:after {
          position: absolute;
          box-sizing: border-box;
          display: block;
          content: '';
          width: calc(100% - 46px);
          border: 1px solid #f0722b;
          height: 1px;
          background: #f0722b;
          bottom: -29px;
        }
      }
    }
  }
}
</style>
